<template>
  <div class="item-thumbs">
    <div class="item-thumb-list">
      <div
        class="item-thumb"
        :style="'width: ' + ((items && items.length > 1) ? '50' : '100') + '%'"
        v-for="(item, itemIdx) in items"
        :key="itemIdx"
      >
        <img
          v-if="
            (item.description.jewelleryType > 0 &&
              item.description.jewelleryType != 5) ||
            onlyBasicModels
          "
          @click="switchCurrentItem(itemIdx)"
          :number-items="items.length"
          :class="{ jewellery: item.description.jewelleryType > 0 }"
          :src="
            getApiHost +
            '/v2/images/item/ffffff/600/600/' +
            item.itemnumber.toUpperCase() +
            '.jpg'
          "
          :alt="item.itemnumber.toUpperCase()"
        />
        <img
          v-else-if="item.description.jewelleryType == 5"
          :number-items="items.length"
          @click="switchCurrentItem(itemIdx)"
          class="jewellery"
          :src="
            appUrl +
            '/img/assets/stones/exchange/stone_' +
            item.description.stones.diamondStock.stoneform.toLowerCase() +
            '.jpg'
          "
          :alt="item.itemnumber.toUpperCase()"
        />
        <img
          v-else
          class="weddingbands"
          :number-items="items.length"
          @click="switchCurrentItem(itemIdx)"
          :src="
            getApiHost +
            '/v2/images/item/ffffff/600/600/' +
            item.itemnumber.toUpperCase() +
            '.jpg'
          "
          :alt="item.itemnumber.toUpperCase()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Config from "@/vuex/Config";

export default {
  name: "ImageThumbs",
  data() {
    return {
      appUrl: Config.getters.getAppUrl,
    };
  },
  props: ["items", "onlyBasicModels", "getApiHost"],
  mounted() {},
  methods: {
    switchCurrentItem: function (newCurrentItem) {
      if (Config.getters.getConfig.visualMode !== "images") {
        let isItemWeddingRing =
          this.$parent.$parent["isCurrentItemWeddingRing"](newCurrentItem);
        let currentVarType = Config.getters.getcurrentVarType;

        if (
          isItemWeddingRing &&
          (currentVarType === "stones/jewellery/normal" ||
            currentVarType === "stones/jewellery/model")
        ) {
          Config.dispatch("setCurrentVarType", "jewellery/stones");
        }
      }

      this.$parent.$parent.$parent["setCurrentItem"](newCurrentItem);

      if (Config.getters.getcurrentVarType !== "") {
        this.$root.$emit("configure");
      } else {
        Config.dispatch("setVisualMode", "show");
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
div.item-thumbs {
  padding: 0;
  display: inline-flex;
  justify-content: center;

  .item-thumb-list {
    display: flex;
    flex-flow: wrap;
    margin-top: 0;
  }

  div.item-thumb {
    display: inline-flex;
    width: 50%;
    border: none;

    &:has([number-items="3"]) {
      &:last-child {
        width: 100%;
      }
    }

    &:has([number-items="2"]) {
      width: 100%;
    }

    img {
      margin: auto;
      position: relative;
      width: 100%;
      max-width: 20rem;

      @media (min-width: 768px) {
        max-width: 25rem;
      }
    }
  }
}
</style>
